

export class DesignationAddInput implements IDesignationAddInput {
    /** The designation type name with 255 character limit */
    designationName!: string;

    constructor(data?: IDesignationAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationName = _data["designationName"];
        }
    }

    static fromJS(data: any): DesignationAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationName"] = this.designationName;
        return data; 
    }
}

export interface IDesignationAddInput {
    /** The designation type name with 255 character limit */
    designationName: string;
}

